(function () {
  'use strict';

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lb-reveal:not(.lb-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('lb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initColors(root) {
    (root || document).querySelectorAll('[data-lb-colors]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var btns = wrap.querySelectorAll('.lb-swatch');
      var stage = wrap.querySelector('.lb-flame');
      var name = wrap.querySelector('.lb-mood__name');
      var text = wrap.querySelector('.lb-mood__text');
      var idx = 0, timer = null;
      function pick(i) {
        var b = btns[i]; if (!b) return; idx = i;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        wrap.style.setProperty('--lb-cur', b.dataset.color);
        if (stage) stage.style.setProperty('--lb-cur', b.dataset.color);
        if (name) name.textContent = b.dataset.name;
        if (text) text.textContent = b.dataset.text;
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { pick(i); if (timer) { clearInterval(timer); timer = null; } });
      });
      pick(0);
      var auto = parseInt(wrap.dataset.auto || '0', 10);
      if (auto > 0 && btns.length > 1) timer = setInterval(function () { pick((idx + 1) % btns.length); }, auto * 1000);
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-lb-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var slides = g.querySelectorAll('.lb-gallery__slide');
      var thumbs = g.querySelectorAll('.lb-thumb');
      var cur = 0;
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        var t = thumbs[cur]; if (t && t.scrollIntoView) { t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' }); }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var p = g.querySelector('.lb-gallery__nav--prev'), n = g.querySelector('.lb-gallery__nav--next');
      if (p) p.addEventListener('click', function () { go(cur - 1); });
      if (n) n.addEventListener('click', function () { go(cur + 1); });
      var main = g.querySelector('.lb-gallery__main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); x0 = null;
        });
      }
      g.goToMedia = function (id) {
        slides.forEach(function (s, k) { if (s.dataset.mediaId === String(id)) go(k); });
      };
    });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-lb-product]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var dataEl = wrap.querySelector('script[data-lb-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceNow = wrap.querySelectorAll('[data-lb-price]');
      var priceWas = wrap.querySelectorAll('[data-lb-compare]');
      var saveEl = wrap.querySelectorAll('[data-lb-save]');
      var btn = form ? form.querySelector('[data-lb-add]') : null;
      var gallery = wrap.querySelector('[data-lb-gallery]');
      var fmt = wrap.dataset.moneyFormat || '{{amount_with_comma_separator}} €';

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',');
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
                  .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                  .replace(/\{\{\s*amount\s*\}\}/, v);
      }

      function update() {
        var sel = [];
        wrap.querySelectorAll('.lb-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); if (c) { sel.push(c.value); var b = fs.querySelector('legend b'); if (b) b.textContent = c.value; }
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (el) { el.textContent = money(v.price); });
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.forEach(function (el) { el.textContent = onSale ? money(v.compare_at_price) : ''; el.hidden = !onSale; });
        saveEl.forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; });
        if (btn) {
          btn.disabled = !v.available;
          var label = btn.querySelector('span'); if (label) label.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        }
        if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      wrap.querySelectorAll('.lb-opt input').forEach(function (i) { i.addEventListener('change', update); });

      var qty = wrap.querySelector('.lb-qty input');
      wrap.querySelectorAll('.lb-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + (b.dataset.step === '+' ? 1 : -1);
          qty.value = Math.max(1, v);
        });
      });

      var sticky = document.querySelector('[data-lb-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        var so = new IntersectionObserver(function (es) {
          es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        });
        so.observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); });
      }
    });
  }

  function initAll(root) { initReveal(root); initColors(root); initGallery(root); initProduct(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();